import React, { useEffect } from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from './actions';
import ProposalForm from './components/DuplicateForm';
import * as selectors from './selectors';

const Container = ({ closeModal, filterData, isOpenModal, mode, reset }) => {
    const { t } = useTranslation();

    useEffect(() => {
        return () => reset();
    }, []);

    return (
        <Dialog
            onClose={() => closeModal()}
            onExited={() => closeModal()}
            open={isOpenModal}
            title={
                mode === 'duplicate'
                    ? `${t('Duplicate')} ${t('Proposal').toLowerCase()}`
                    : t('Rename proposal')
            }
            size="sm"
        >
            <ProposalForm mode={mode} filterData={filterData} />
        </Dialog>
    );
};

Container.propTypes = {
    closeModal: PropTypes.func,
    filterData: PropTypes.object,
    isOpenModal: PropTypes.bool,
    mode: PropTypes.string,
    reset: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    isOpenModal: selectors.getIsOpenModal,
    mode: selectors.getMode,
});

const mapDispatchToProps = (dispatch) => ({
    reset: () => dispatch(actions.reset()),
    closeModal: () => dispatch(actions.closeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
